import { Empty, Table, Tag } from "antd";
import { observer } from "mobx-react";
import { useMemo } from "react";
import { __ } from "../../../../utils";
import { AccountLicenseActions, AccountLicenseExpand } from ".";
import { MinusSquareOutlined, PlusSquareOutlined } from "@ant-design/icons";
const {
  Column,
  ColumnGroup
} = Table;
const AccountLicensesTable = observer(_ref => {
  var _records$;
  let {
    records
  } = _ref;
  const isLifetime = records === null || records === void 0 ? void 0 : (_records$ = records[0]) === null || _records$ === void 0 ? void 0 : _records$.subscription.isLifetime;
  const canBeModified = records.some(license => license.subscription.canBeModified);

  // Always expand the first row
  const defaultExpandedRowKeys = useMemo(() => {
    var _records$2;
    return [(_records$2 = records[0]) === null || _records$2 === void 0 ? void 0 : _records$2.data.id];
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isLifetime &&
  /*#__PURE__*/
  // Subscription licenses can always be modified
  React.createElement("p", null, __("Your subscriptions offer you to use products in production and development environments. You can manage your own licenses up to the limits of your subscriptions.")), isLifetime && canBeModified &&
  /*#__PURE__*/
  // Subscription licenses can always be modified
  React.createElement("p", null, __("Your product offer you the possibility to use it in production and development environments. You can manage your own licenses up to the limits of the license package you purchased.")), /*#__PURE__*/React.createElement(Table, {
    bordered: true,
    locale: {
      emptyText: /*#__PURE__*/React.createElement(Empty, {
        description: __("No licenses created")
      })
    },
    pagination: false,
    dataSource: records,
    rowKey: row => row.data.id,
    size: "small",
    expandable: {
      // eslint-disable-next-line react/display-name
      expandedRowRender: record => /*#__PURE__*/React.createElement(AccountLicenseExpand, {
        record: record
      }),
      // TODO: rowExpandable: ({ data: { status } }) => status !== ESubscriptionStatus.Canceled,
      defaultExpandedRowKeys,
      // eslint-disable-next-line react/display-name
      expandIcon: _ref2 => {
        let {
          expanded,
          onExpand,
          record
        } = _ref2;
        return /*#__PURE__*/React.createElement(Tag, {
          style: {
            cursor: "pointer"
          },
          onClick: e => onExpand(record, e),
          icon: expanded ? /*#__PURE__*/React.createElement(MinusSquareOutlined, null) : /*#__PURE__*/React.createElement(PlusSquareOutlined, null)
        }, expanded ? __("Less") : __("More"));
      },
      expandedRowClassName: () => "real-commerce-white-expandable"
    },
    showHeader: records.length > 0
  }, /*#__PURE__*/React.createElement(Column, {
    title: __("License key / Description"),
    dataIndex: "licenseKey",
    key: "licenseKey",
    render: (_, _ref3) => {
      let {
        data: {
          licenseKey,
          description
        }
      } = _ref3;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("code", null, licenseKey), !!description && /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, description));
    }
  }), /*#__PURE__*/React.createElement(Column, {
    title: __("Product"),
    dataIndex: "product",
    key: "product",
    render: (_, _ref4) => {
      let {
        data: {
          productVariant: {
            name
          }
        }
      } = _ref4;
      return name;
    }
  }), /*#__PURE__*/React.createElement(ColumnGroup, {
    title: __("Max. installations")
  }, /*#__PURE__*/React.createElement(Column, {
    title: __("Production"),
    dataIndex: "maxInstallationsProduction",
    key: "maxInstallationsProduction",
    render: (_, _ref5) => {
      let {
        data: {
          maxInstallationsProduction
        }
      } = _ref5;
      return maxInstallationsProduction;
    }
  }), /*#__PURE__*/React.createElement(Column, {
    title: __("Development"),
    dataIndex: "maxInstallationsDevelopment",
    key: "maxInstallationsDevelopment",
    render: (_, _ref6) => {
      let {
        data: {
          maxInstallationsDevelopment
        }
      } = _ref6;
      return maxInstallationsDevelopment;
    }
  })), canBeModified && /*#__PURE__*/React.createElement(Column, {
    title: __("Actions"),
    dataIndex: "actions",
    key: "actions",
    align: "right",
    render: (_, record) => /*#__PURE__*/React.createElement(AccountLicenseActions, {
      record: record
    })
  })));
});
export { AccountLicensesTable };